import { Controller } from "@hotwired/stimulus"
import cytoscape from "cytoscape"
import fcose from "cytoscape-fcose"

cytoscape.use(fcose)

// Renders the friendship graph. Elements (nodes with a cluster colour + first
// name, weighted edges) are embedded as JSON in a data attribute. The canvas
// is not screen-reader accessible, so the view also provides an equivalent
// data table; this container is marked role="img" with a summary label.
export default class extends Controller {
  static values = { elements: Array }

  connect() {
    this.cy = cytoscape({
      container: this.element,
      elements: this.elementsValue,
      style: [
        {
          selector: "node",
          style: {
            "background-color": "data(color)",
            "label": "data(label)",
            "font-size": "11px",
            "font-family": "Montserrat, sans-serif",
            "width": 24,
            "height": 24,
            "text-valign": "bottom",
            "text-margin-y": 3,
            "color": "#1f2937"
          }
        },
        {
          selector: "edge",
          style: {
            "width": "mapData(weight, 1, 45, 1.5, 7)",
            "line-color": "#cbd5e1",
            "opacity": 0.7,
            "curve-style": "haystack"
          }
        }
      ],
      layout: { name: "fcose", animate: false, padding: 24, nodeSeparation: 90 },
      autoungrabify: false,
      minZoom: 0.3,
      maxZoom: 2.5
    })
  }

  disconnect() {
    if (this.cy) {
      this.cy.destroy()
      this.cy = null
    }
  }
}
